var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.hasTermsAndPrivacy)?_c('div',{class:`
    d-flex
    align-center
    justify-center
    flex-gap-1
    pa-4
    terms-and-privacy
    terms-and-privacy__${_vm.variant}
  `},[_c('a',{attrs:{"href":_vm.termsUrl,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v("\n    "+_vm._s(_vm.$t("_core.termsAndPrivacy.terms"))+"\n  ")]),_vm._v(" "),_c('span',{staticClass:"divider-element"}),_vm._v(" "),_c('a',{attrs:{"href":_vm.privacyUrl,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v("\n    "+_vm._s(_vm.$t("_core.termsAndPrivacy.privacy"))+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }